import React from 'react';
import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';

const DeleteSeriesDialog = ({ visible, onHide, onDeleteSingle, onDeleteSeries }) => {
    const deleteSeriesDialogFooter = (
        <>
            <Button 
                label="Cancel" 
                icon="pi pi-times" 
                className="p-button-text" 
                onClick={onHide} 
            />
            <Button 
                label="This Event Only" 
                icon="pi pi-calendar" 
                className="p-button-secondary" 
                onClick={onDeleteSingle} 
            />
            <Button 
                label="Entire Series" 
                icon="pi pi-trash" 
                className="p-button-danger" 
                onClick={onDeleteSeries} 
            />
        </>
    );

    return (
        <Dialog
            visible={visible}
            header="Delete Recurring Event"
            modal
            footer={deleteSeriesDialogFooter}
            onHide={onHide}
            className="series-delete-dialog frazza-dialog-md"
        >
            <div className="event-delete-confirmation">
                <div className="frazza-alert-icon warning">
                    <i className="pi pi-exclamation-triangle" />
                </div>
                <div className="frazza-alert-content">
                    <h4 className="frazza-alert-title">This is a recurring event</h4>
                    <p className="frazza-alert-message">Would you like to delete just this occurrence, or the entire series of recurring events?</p>
                </div>
            </div>
        </Dialog>
    );
};

export default DeleteSeriesDialog;